import { UFS, semAcento } from '../../../../constants/ufs';

// Naturalidade lida do RG ou da CNH, como "Cidade/UF". Os dois vêm em caixa alta: a cidade sai
// como nome próprio ("Sao Jose dos Campos", "Embu-Guaçu", "Mirassol d'Oeste"), a UF como sigla.
const MINUSCULAS = new Set(['da', 'das', 'de', 'do', 'dos', 'e']);

const maiuscula = (p: string) => p.charAt(0).toUpperCase() + p.slice(1);

const palavra = (p: string, i: number): string => {
  if (i > 0 && MINUSCULAS.has(p)) return p;
  if (/^d['’]./.test(p)) return p.slice(0, 2) + maiuscula(p.slice(2));
  return p.split('-').map(maiuscula).join('-');
};

// Sigla ou nome do estado ("GO", "GOIÁS"); fora da lista, nada (não inventa UF).
const siglaDaUf = (uf?: string | null): string => {
  const alvo = semAcento(uf ?? '').replace(/\./g, '');
  return UFS.find(u => u.sigla.toLowerCase() === alvo || semAcento(u.nome) === alvo)?.sigla ?? '';
};

export const naturalidadeLida = (cidade?: string | null, uf?: string | null): string => {
  let c = (cidade ?? '').trim().replace(/\s+/g, ' ');
  // Sem a UF no campo dela, a que vem no fim da cidade ("GOIANIA-GO"), se for uma UF de verdade.
  const sigla = siglaDaUf(uf) || siglaDaUf(/[\s,/-]+([A-Za-z]{2})$/.exec(c)?.[1]);
  // O RG costuma trazer a UF no mesmo campo ("GOIANIA-GO"): ela sai daqui e entra uma vez só.
  if (sigla) c = c.replace(new RegExp(`[\\s,/-]+${sigla}$`, 'i'), '').trim();
  if (!c) return '';
  const nome = c === c.toUpperCase() ? c.toLowerCase().split(' ').map(palavra).join(' ') : c;
  return sigla ? `${nome}/${sigla}` : nome;
};
